import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { Apirequests } from '../../utils/ApiRequests';
import { ErrorTost, SuccessTost } from '../../utils/ToastHelper';
import SpinningLogo from '../../components/Spinner';
import CustomPageHeader from '../../components/CustomPageHeader';
import { downloadExcel } from '../../utils/DownloadXls';
import BtnSpinner from '../../components/BtnSpinner';
import { Edit, Trash } from 'lucide-react';
import Pagination from '../../components/Pagination';
import moment from 'moment';
import CustomOffCanvas from '../../components/CustomOffCanvas';
import EventDetails from './EventDetails';
import AddOrEditEvent from './AddOrEditEvent';

function Events() {


  const [isOffCanvasOpen, setIsOffCanvasOpen] = useState({ state: false, name: "" });
  const [events, setEvents] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState({ state: false, name: "" });
  const [currentPage, setCurrentPage] = useState(1);
  const [refresh, setRefresh] = useState(false);
  const [currentEvent, setCurrentEvent] = useState(null);
  const [deleteId, setdeleteId] = useState(null)

  const token = localStorage.getItem("token");


  const totalItems = events?.length; // Total number of items
  const itemsPerPage = 10;

  const currentData = events?.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const navigate = useNavigate();

  const handleRefresh = () => setRefresh(!refresh);

  const handleSearch = async () => {
    if (!searchTerm) {
      return ErrorTost("Enter a key to serach")
    }

    if(currentPage!==1){
      setCurrentPage(1)
    }
    
    await fetchEvents(searchTerm)
  };

  const fetchEvents = async () => {

    setLoading({ state: true, name: "fetchevents" });

    try {
      const fetchedEvents = await Apirequests(`events/get-events?q=${searchTerm}`, 'GET', {}, {
        Authorization: `Bearer ${token}`
      });
      // console.log(fetcedclasses,'fetch class res')
      if (fetchedEvents?.success) {
        setEvents(fetchedEvents?.data)
      }
    } catch (error) {
      console.log('fetch classes error')
    }
    setLoading({ state: false, name: "" })
  }

  const deleteEvent = async (id) => {
    setdeleteId(id);
    setLoading({ state: true, name: "deleteEvent" })
    try {
      const delRes = await Apirequests(`events/delete-event/${id}`, 'DELETE', {}, {
        Authorization: `Bearer ${token}`
      });

      if (delRes?.success) {
        SuccessTost(delRes?.message);
        setRefresh(!refresh)
      } else {
        ErrorTost(delRes?.message)
      }
    } catch (error) {
      console.log(error, 'delete class error');
      ErrorTost("Something went wrong, please try again later.")
    }
    setLoading({ state: false, name: "" })
  }


  useEffect(() => {
    fetchEvents()
  }, [refresh, token])

  if (loading.state && loading.name === "fetchevents") {
    return <div className='h-screen w-full flex items-center justify-center bg-[rgba(255,255,255,0.5)]'>
      <SpinningLogo />
    </div>
  }

  return (
    <div>
      <CustomPageHeader
        title={"Events"}
        text={searchTerm}
        setText={setSearchTerm}
        handleSearch={handleSearch}
        onClick={() => setIsOffCanvasOpen({ state: true, name: "addevent" })}
        btnText={"Add Event"}
        handleBackClick={() => navigate("/")}
        handleRefresh={handleRefresh}
        handleDownload={() => downloadExcel(events, 'events')}
      />

      <main className="mx-auto py-6 sm:px-6 lg:px-8">
        <div className="px-4 py-6 sm:px-0">
          <div className="overflow-x-auto">
            <table className="min-w-full bg-white">
              <thead className="bg-gray-50 text-center">
                <tr>
                  {/* <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Event Id</th> */}
                  <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Event Title</th>
                  <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Price</th>
                  <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Language</th>
                  <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Date</th>
                  <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Time</th>
                  <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
                  <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Created At</th>
                  <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200 text-center">
                {currentData?.map((event) => (
                  <tr key={event._id}>

                    <td className="px-6 py-4 whitespace-nowrap"><span className='text-indigo-600 cursor-pointer' onClick={() => { setIsOffCanvasOpen({ state: true, name: "viewevent" }); setCurrentEvent(event) }}>{event?.title}</span></td>
                    {/* <td className="px-6 py-4 whitespace-nowrap">{cl?.class_title}</td> */}
                    <td className="px-6 py-4 whitespace-nowrap">{event?.price}</td>
                    <td className="px-6 py-4 whitespace-nowrap">{event?.language}</td>
                    <td className="px-6 py-4 whitespace-nowrap">{event?.date}</td>
                    <td className="px-6 py-4 whitespace-nowrap">{event?.time}</td>
                    <td className="px-6 py-4 whitespace-nowrap">{event?.status}</td>
                    <td className="px-6 py-4 whitespace-nowrap">{moment(event?.createdAt).format("DD-MM-YY")}</td>
                    <td className="px-6 py-4 flex gap-5 justify-center">
                      <button className='flex bg-indigo-400 rounded-lg px-3 py-2 items-center gap-1' onClick={() => { setIsOffCanvasOpen({ state: true, name: "editevent" }); setCurrentEvent(event) }}>
                        <Edit className='text-white' size={20} />
                        <span className='text-white text-sm'>Edit</span>
                      </button>
                      <button className='flex bg-red-200 rounded-lg px-3 py-2 items-center gap-1' onClick={() => deleteEvent(event?._id)}>
                        {
                          loading.state && loading.name === "deletevent" && deleteId === event?._id ?
                            <BtnSpinner /> :
                            <>
                              <Trash className='text-red-700 text-sm' size={20} />
                              <span className='text-red-700 text-sm'>Delete</span>
                            </>
                        }

                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        {events?.length ?
          <div className="flex gap-x-2 items-center justify-between">
            <p>total: {events?.length}</p>
            <Pagination
              page={currentPage}
              totalItems={totalItems}
              itemsPerPage={itemsPerPage}
              onPageChange={handlePageChange}
            />
          </div> : null}
      </main>

      <CustomOffCanvas
        open={isOffCanvasOpen.state && isOffCanvasOpen?.name === "viewevent"}
        close={() => { setIsOffCanvasOpen({ state: false, name: "" }); setCurrentEvent(null) }}
        content={
          <EventDetails
            close={() => { setIsOffCanvasOpen({ state: false, name: "" }); setCurrentEvent(null) }}
            setRefresh={setRefresh}
            event={currentEvent}
          />
        }
      />

      <CustomOffCanvas
        open={isOffCanvasOpen.state && isOffCanvasOpen?.name === "addevent"}
        close={() => { setIsOffCanvasOpen({ state: false, name: "" }); setCurrentEvent(null) }}
        content={
          <AddOrEditEvent
            close={() => { setIsOffCanvasOpen({ state: false, name: "" }); setCurrentEvent(null) }}
            setRefresh={setRefresh}
            event={currentEvent}
          />
        }
      />

      <CustomOffCanvas
        open={isOffCanvasOpen.state && isOffCanvasOpen?.name === "editevent"}
        close={() => { setIsOffCanvasOpen({ state: false, name: "" }); setCurrentEvent(null) }}
        content={
          <AddOrEditEvent
            close={() => { setIsOffCanvasOpen({ state: false, name: "" }); setCurrentEvent(null) }}
            setRefresh={setRefresh}
            event={currentEvent}
          />
        }
      />
    </div>
  )
}

export default Events